import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FilterByIdPipe} from "./filter-by-id.pipe";



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FilterByIdPipe
  ],
  exports: [
    FilterByIdPipe
  ]
})
export class PipesModule { }
